import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Link, Navigate } from "react-router-dom";
import { Container, Card, CardBody, Col, Form, Input, Label, Row, Spinner, Alert, Button } from "reactstrap";
import { LoginForm, logoutUser, userLogin } from "../../redux/login/actions";

const mapStateToProps = (state) => ({
  data: state.Login.data,
  isAuth: state.Login.isAuth,
  isloading: state.Login.isloading,
  errorMessage: state.Login.errorMessage
})

const mapDispatchToProps = (dispatch) => ({
  LoginForm: (data) => dispatch(LoginForm(data)),
  userLogin: () => dispatch(userLogin()),
  resetLoginForm: (data) => dispatch(logoutUser(data)),
})

const Login = (props) => {
  const { data, errorMessage } = props;

  const changeHandler = e => {
    const { name, value } = e.target;
    props.LoginForm({ ...props.data, [name]: value })
  }

  const submitHandler = async (e) => {
    e.preventDefault();
    props.userLogin();
  };

  useEffect(() => {
    props.resetLoginForm();
  }, [])

  return props.isAuth ? (<Navigate to="/apps/invoices" />) : (
    <>
      <Container>
        <Row className="justify-content-center align-items-center" style={{ height: "100vh" }}>
          <Col lg={6} md={8} xl={4} >
            <Card>
              <CardBody className="p-4">
                <div>
                  <p className="mb-5 text-center">
                    Sign in to continue
                  </p>
                  {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
                  <Form className="form-horizontal">
                    <Row>
                      <Col md={12}>
                        <div className="mb-4">
                          <Label>
                            Email
                          </Label>
                          <br></br>
                          <Input
                            name="email"
                            placeholder="Email"
                            type="email"
                            value={data && data.email}
                            onChange={changeHandler}
                          />
                        </div>
                        <div className="mb-4">
                          <Label>
                            Password
                          </Label>
                          <br></br>
                          <Input
                            name="password"
                            placeholder="Password"
                            type="password"
                            value={data && data.password}
                            onChange={changeHandler}
                          />
                        </div>
                        <div className="mb-4">
                          <div className="d-grid mt-4">
                            <Button
                              color='dark'
                              onClick={submitHandler}
                              disabled={props.isloading}
                            >
                              {props.isloading ? (
                                <>
                                  <Spinner color="primary"></Spinner>
                                </>
                              ) : (
                                "Log In"
                              )}
                            </Button>
                          </div>
                        </div>
                        <Row>
                          <Col className="col-7">
                            <div style={{ textAlign: 'right', width: '360px' }}>
                              <Link to="/auth/recover" className="text-muted">
                                <i className="mdi mdi-lock"></i> Forgot your password
                              </Link>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

    </>
  );
}


export default connect(mapStateToProps, mapDispatchToProps)(Login);